import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const createIdentityUserApi = async (
  email,
  firstName,
  lastName,
  phoneNumber,
  mobileCountryCode,
  localPhoneNo,
  address,
  platform = "app",
  authHeaders
) => {
  const body = {
    path: "create",
    userAttributes: {
      email,
      firstName: firstName ?? "",
      lastName: lastName ?? "",
      phoneNumber: phoneNumber ?? "",
      mobileCountryCode: mobileCountryCode ?? "",
      localPhoneNo,
      ...(platform === "app" && { address: address ?? "" }),
    },
    platform,
  };

  try {
    const res = await apiCallPost(apiPaths.identityCrmUser, body, authHeaders);

    if (res?.data) {
      return {
        data: res.data,
        status: true,
      };
    }

    return {
      status: false,
      errMsg: res?.error || res?.msg || res?.message || "Error occurred while creating user.",
    };
  } catch (err) {
    const bodyError = err?.responseBody?.error ?? err?.responseBody?.message;
    return {
      status: false,
      errMsg: bodyError || err.message,
    };
  }
};

export const createUserApi = async (
  email,
  firstName,
  lastName,
  phoneNumber,
  mobileCountryCode,
  localPhoneNo,
  address,
  platform = "crm",
  authHeaders,
  params) => {
  const body = {
    path: "create",
    userAttributes: {
      email: email,
      firstName: firstName ?? "",
      lastName: lastName ?? "",
      phoneNumber: phoneNumber ?? "",
      mobileCountryCode: mobileCountryCode ?? "",
      localPhoneNo: localPhoneNo,
      ...(platform === "app" && {
        address: address ?? "",
        acqChannel: "APP",
        acqCompanyId: params?.companyId ?? ""
      })

    },
    platform: platform,
  };

  try {
    const res = await apiCallPost(apiPaths.crmUser, body, authHeaders);

    if (res.data) {
      return {
        data: res.data,
        status: true,
        msg: "User created successfully. Try clicking on search button to get proper result.",
      };
    }

    return {
      status: false,
      errMsg: res.msg || "Error occurred while creating user.",
    };
  } catch (err) {
    return {
      status: false,
      errMsg: err.message,
    };
  }
};

export const updateUserApi = async (
  email,
  firstName,
  lastName,
  platform = "crm",
  authHeaders
) => {
  const body = {
    path: "update",
    userAttributes: {
      firstName: firstName ?? "",
      lastName: lastName ?? "",
      email,              // we need email to identify the user
    },
    platform,
  };

  try {
    const res = await apiCallPost(apiPaths.crmUser, body, authHeaders);
    if (res.data) {
      return { data: res.data, status: true };
    }
    return { status: false, errMsg: res.msg || "Unable to update user." };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
};

export const getUserApi = async (
  email,
  phoneNumber,
  platform = "crm",
  authHeaders
) => {
  const body = {
    path: "get",
    userAttributes:
      email
        ? { email: email }
        : { phoneNumber: phoneNumber ?? "" },
    platform: platform,
  };

  try {
    const res = await apiCallPost(apiPaths.crmUser, body, authHeaders);

    if (res.data) {
      return {
        data: res.data,
        status: true,
      };
    }

    return {
      status: false,
      errMsg: res.msg || "User not found.",
    };
  } catch (err) {
    return {
      status: false,
      errMsg: err.message,
    };
  }
};
export const doesUserExistByEmailApi = async (
  email,
  platform = "app",
  authHeaders
) => {
  const body = {
    path: "does-user-exist-by-email",
    platform,
    userAttributes: { email },
  };

  try {
    const res = await apiCallPost(apiPaths.identityCrmUser, body, authHeaders);

    if (res?.available === true) {
      return { status: true };
    }

    return {
      status: false,
      errMsg: "Email already exists.",
    };
  } catch (err) {
    return {
      status: false,
      errMsg: err.message,
    };
  }
};

export const changePasswordApi = async (
  currentPassword,
  newPassword,
  authHeaders
) => {
  const body = {
    path: "change-password",
    platform: "crm",
    currentPassword,
    newPassword,
  };

  try {
    const res = await apiCallPost(apiPaths.identityCrmUser, body, authHeaders);

    if (res?.status === "SUCCESS") {
      return {
        status: true,
        msg: res.msg || "Password changed successfully.",
      };
    }

    return {
      status: false,
      errMsg: res?.msg || "Failed to change password.",
    };
  } catch (err) {
    return {
      status: false,
      errMsg: err.message,
    };
  }
};

export const deleteUserApi = async ({ email, platform = "crm" }) => {
  const body = {
    email,
    path: "delete",
    platform,
  };

  try {
    const res = await apiCallPost(apiPaths.crmUser, body);

    if (res.status === "SUCCESS") {
      return {
        status: true,
        msg: "User deleted successfully.",
      };
    }

    return {
      status: false,
      errMsg: res.msg || "Error occurred while deleting user.",
    };
  } catch (err) {
    return {
      status: false,
      errMsg: err.message,
    };
  }
};
